import { capitalize } from 'vue'

export default {
  login,
  verify,
  register,
  loginSocial,
  registerSocial,
}

function login() {
  useTracking().send({
    event: 'login',
    action: 'login success',
    label: 'Sign in',
    category: undefined,
    component: 'login-entry-mask',
    position: 'login-page',
    language: useConfdata().language,
    _clear: true,
  })
}

function loginSocial(provider: SocialProvider) {
  useTracking().send({
    event: 'social_login',
    action: 'start',
    label: capitalize(provider),
    category: undefined,
    component: 'login',
    position: 'login-page',
    language: useConfdata().language,
    _clear: true,
  })
}

function register() {
  useTracking().send({
    event: 'register_account',
    action: 'register',
    label: 'Registration',
    category: undefined,
    component: 'register-mask',
    position: 'register-page',
    language: useConfdata().language,
    _clear: true,
  })
}

function registerSocial(provider: SocialProvider) {
  useTracking().send({
    event: 'signup',
    action: 'start',
    label: capitalize(provider),
    category: 'authentication',
    component: 'signup',
    position: 'signup-page',
    language: useConfdata().language,
    _clear: true,
  })
}

function verify() {
  useTracking().send({
    event: 'register_account',
    action: 'verify',
    label: 'Verification',
    category: undefined,
    component: 'register-mask',
    position: 'verify-page',
    language: useConfdata().language,
    _clear: true,
  })
}
